import { http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';

export class ShiftService {
   async getShifts(companyId: number, params?: LocationQuery) {
      return await http.get(`/companies/${companyId}/shifts`, { params }).then((response) => response.data);
   }

   async deleteShift(companyId: number, shiftId: number) {
      return await http.delete(`/companies/${companyId}/shifts/${shiftId}`).then((response) => response.data);
   }

   async postShift(companyId: number, body: any) {
      return await http.post(`/companies/${companyId}/shifts`, body, { params: { append: 'scopes' } }).then((response) => response.data);
   }

   async putShift(companyId: number, body: any) {
      return await http
         .put(`/companies/${companyId}/shifts/${body.id}`, body, { params: { append: 'scopes' } })
         .then((response) => response.data);
   }
}
